module.exports = __webpack_public_path__ + "static/impact-webfont-097ec957e76ffd385f57d2e9a3354fea.eot";